<template>
  <div class="multiple-score">
    <el-button class="back" @click="$router.back()" size="small">返回</el-button>
    <!-- <div class="exam-list">
      <div class="exam-item" v-for="item in multipleScoreData" :key="item.id">
        <div class="title">{{ item.title }}</div>
        <div class="subTitle">副标题：{{ item.subTitle }}</div>
        <div class="score-info-button" @click.stop="toDetail(item)">查看各科目成绩</div>
      </div>
    </div>
    <scoreDialog
      :dialogVisible.sync="scoreDialogShow"
      :multipleScoreItem="multipleScoreItem"
      v-if="scoreDialogShow"
    /> -->
    <div
      class="chart-container"
      ref="chart"
      id="mychart"
      style="height: 600px; width: 96%; margin: 20px auto"
    ></div>
  </div>
</template>

<script>
// import scoreDialog from "./components/score-dialog/scoreDialog.vue";
import * as echarts from "echarts";
export default {
  data() {
    return {
      studentInfo: {},
      multipleScoreData: [],
      scoreDialogShow: false,
      multipleScoreItem: {},
    };
  },
  components: {
    // scoreDialog,
  },
  created() {
    this.studentInfo = this.$route.query;
    this.selectExamInfoByStudentId();
  },
  // mounted() {
  //   // console.log("this.multipleScoreItem.scoreList==>", this.multipleScoreItem.scoreList);
  //   this.$nextTick(() => {

  //   });
  // },
  methods: {
    selectExamInfoByStudentId() {
      let data = {
        studentId: this.studentInfo.studentId,
        classId: this.studentInfo.classId,
      };
      this.get(this.$url.selectExamInfoByStudentId, data).then((res) => {
        // console.log("查询学生多次考试成绩==>", res);
        this.multipleScoreData = res.data;
        this.initChart();
      });
    },
    toDetail(item) {
      this.multipleScoreItem = item;
      this.scoreDialogShow = true;
    },
    initChart() {
      const chart = echarts.init(document.getElementById("mychart"));

      // const scoreList = this.multipleScoreItem.scoreList;

      // 使用 Set 提取不重复的 courseName
      const uniqueCourseNames = new Set();
      const uniqueTitles = new Set();

      this.multipleScoreData.map((item) => {
        uniqueTitles.add(`${item.title}\n${item.subTitle}`);
        item.scoreList.forEach((scoreItem) => {
          // courseNames.add(scoreItem.courseName);
          uniqueCourseNames.add(scoreItem.courseName);
        });
      });
      const courseNamesArray = Array.from(uniqueCourseNames);
      // 将 Set 转换为数组
      const titlesArray = Array.from(uniqueTitles);

      const transformedData = [];

      this.multipleScoreData.forEach((item) => {
        item.scoreList.forEach((scoreItem) => {
          const existingDataIndex = transformedData.findIndex(
            (dataItem) => dataItem.name === scoreItem.courseName
          );

          if (existingDataIndex !== -1) {
            // 如果已经存在相同科目名称的数据
            transformedData[existingDataIndex].data.push(scoreItem.score || 0);
          } else {
            // 如果还不存在相同科目名称的数据
            transformedData.push({
              name: scoreItem.courseName,
              type: "bar",
              data: [scoreItem.score || 0],
              markPoint: {
                data: [
                  { type: "max", name: "Max" },
                  { type: "min", name: "Min" },
                ],
              },
              markLine: {
                // data: [{ type: "average", name: "Avg" }],
              },
            });
          }
        });
      });

      // console.log("transformedData==>", transformedData);
      // console.log("courseNamesArray==>", courseNamesArray);
      // console.log("titlesArray==>", titlesArray);
      // const xAxisData = scoreList.map((item) => item.courseName);
      // const seriesData = scoreList.map((item) => (item.score !== null ? item.score : 0));
      //   console.log(xAxisData, seriesData);

      const option = {
        title: {
          text: this.studentInfo.studentName + "多次考试成绩详情",
          // subtext: "Fake Data",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: courseNamesArray,
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar"] },
            // restore: { show: true },
            // saveAsImage: { show: true },
          },
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            // prettier-ignore
            data: titlesArray,
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: transformedData,
      };

      // 指定图表的配置项和数据
      chart.setOption(option);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        chart.resize();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./achievementMultipleScore.scss";
</style>
